import React from 'react';
import * as PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';

const EPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const EPanelSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiExpansionPanelDetails);

const ExpansionPanels = ({ elements }) => {
  const [expanded, setExpanded] = React.useState('');

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : '');
  };

  if (!elements) {
    return null;
  }

  return (
    <div>
      {elements.map((item, index) => (
        <EPanel key={`${item.title}`} square expanded={expanded === `panel${index}`} onChange={handleChange(`panel${index}`)}>
          <EPanelSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography>
              {item.title}
            </Typography>
          </EPanelSummary>
          <ExpansionPanelDetails>
            {item.children}
          </ExpansionPanelDetails>
        </EPanel>
      ))}
    </div>
  );
};

ExpansionPanels.defaultProps = {
  elements: null,
};

ExpansionPanels.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  })),
};

export default ExpansionPanels;
